module.exports = __webpack_public_path__ + "static/media/info-icon.1281dbf3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/info-icon.svg
// module id = 646
// module chunks = 0